import type { PollService } from "@busbud/core-types";

export const isUDMV4 = function (
  trip:
    | PollService.API.RelatedPublicTrip
    | PollService.API.PublicTrip
    | PollService.API.PublicTripV4
    | PollService.API.RelatedPublicTripV4
): trip is PollService.API.PublicTripV4 | PollService.API.RelatedPublicTripV4 {
  return (
    trip && (trip.hasOwnProperty("classes") || trip.hasOwnProperty("class_ids"))
  );
};
